import { render, staticRenderFns } from "./ProductServiceDetail.vue?vue&type=template&id=6f99bf33&scoped=true"
import script from "./ProductServiceDetail.vue?vue&type=script&lang=js"
export * from "./ProductServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceDetail.vue?vue&type=style&index=0&id=6f99bf33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99bf33",
  null
  
)

export default component.exports